const fr = {
  common: {
    brand: "Consultants Sparks",
    tagline: "Projets. Humains. Croissance.",
    menu: "Menu",
    close: "Fermer",
    loading: "Chargement…",
    save: "Enregistrer",
    saving: "Enregistrement…",
    cancel: "Annuler",
    submit: "Envoyer",
    back: "Retour",
    next: "Suivant",
    previous: "Précédent",
    required: "Obligatoire",
    optional: "facultatif",
    yes: "Oui",
    no: "Non",
    search: "Rechercher",
    filters: "Filtres",
    clear: "Réinitialiser",
    all: "Tous",
    none: "Aucun",
    language: "Langue",
    error: "Une erreur est survenue. Veuillez réessayer.",
  },
  nav: {
    home: "Accueil",
    about: "À propos",
    opportunities: "Opportunités",
    realEstate: "Immobilier",
    careers: "Carrières",
    humanDev: "Développement humain",
    projects: "Projets",
    contact: "Nous joindre",
  },
  cta: {
    discover: "Découvrir les opportunités",
    apply: "Soumettre ma candidature",
    talk: "Parler avec notre équipe",
    exploreRealEstate: "Explorer une carrière en immobilier",
    login: "Connexion",
    register: "Créer un compte",
    portal: "Mon portail",
    admin: "Administration",
    logout: "Déconnexion",
  },
  home: {
    heroKicker: "Projets. Humains. Croissance.",
    heroL1: "Développer les projets.",
    heroL2: "Révéler le potentiel.",
    heroL3: "Créer la croissance.",
    heroSub: "Consultants Sparks accompagne les personnes, les équipes et les organisations dans le développement de nouvelles opportunités, de projets et de carrières.",
    pillarsKicker: "Trois piliers",
    pillars: {
      projects: { title: "Projets", body: "Nous contribuons à transformer les opportunités en initiatives structurées et durables." },
      people: { title: "Humains", body: "Nous identifions, développons et accompagnons les personnes prêtes à évoluer." },
      growth: { title: "Croissance", body: "Nous créons des connexions entre talents, organisations et opportunités." },
    },
    journeyKicker: "Le parcours",
    journeyTitle: "Un accompagnement structuré, du premier contact au leadership",
    journeyLead: "Chaque personne avance à son rythme. Notre rôle est de rendre chaque étape claire et atteignable.",
    journey: [
      { title: "Découvrir", body: "Comprendre où votre potentiel peut vous mener." },
      { title: "Évaluer", body: "Un échange humain pour situer vos forces et vos objectifs." },
      { title: "Orienter", body: "Identifier la direction professionnelle la plus cohérente." },
      { title: "Former", body: "Développer les compétences nécessaires à la réussite." },
      { title: "Déployer", body: "Commencer dans un rôle concret, avec du soutien." },
      { title: "Développer", body: "Progresser, prendre des responsabilités, aider les autres à grandir." },
    ],
    verticalsKicker: "Domaines d'intervention",
    verticalsTitle: "Des secteurs variés, une même exigence",
    verticalsLead: "Nos champs d'action évoluent avec les besoins des personnes et des organisations que nous accompagnons.",
    orgKicker: "Pour les organisations et les projets",
    orgTitle: "Structurer des équipes, activer des opportunités",
    orgBody: "Nous travaillons avec des organisations et des porteurs de projets pour identifier les talents, structurer les équipes, développer des marchés et créer des partenariats durables.",
    orgItems: [
      "Identifier et attirer les bonnes personnes",
      "Structurer et développer les équipes",
      "Développer de nouveaux marchés",
      "Créer des partenariats durables",
    ],
    closingTitle: "Où votre potentiel peut-il vous mener ?",
    closingBody: "Vous n'avez pas besoin de savoir exactement quel chemin vous convient. Commencez par une conversation.",
  },
  about: {
    kicker: "À propos",
    title: "Une organisation qui développe des projets et des personnes",
    lead: "Consultants Sparks est une organisation de développement : de projets, de personnes, d'équipes et de croissance.",
    p1: "Nous ne sommes pas une agence de placement ni un babillard d'emplois. Notre travail consiste à créer des liens durables entre les ambitions des personnes et les besoins réels des organisations et des projets.",
    p2: "Notre approche est structurée, humaine et vérifiable. Nous avançons par étapes claires, avec des décisions prises par des personnes, jamais par des automatismes.",
    valuesKicker: "Nos principes",
    values: [
      { title: "Rigueur", body: "Des processus clairs, documentés et respectueux des personnes." },
      { title: "Confidentialité", body: "Les relations d'affaires et les données personnelles restent protégées." },
      { title: "Progression", body: "Une organisation grandit lorsque les personnes qui la composent grandissent." },
    ],
    scaleKicker: "Notre portée",
    scaleTitle: "Conçu pour croître",
    scaleBody: "Notre architecture organisationnelle est pensée pour opérer à l'échelle locale, provinciale, nationale et internationale.",
    scaleItems: ["Local", "Provincial / État", "National", "International"],
  },
  opportunities: {
    kicker: "Opportunités",
    title: "Explorer les grandes catégories d'opportunités",
    lead: "Voici les catégories générales dans lesquelles Consultants Sparks développe des personnes, des équipes et des projets.",
    note: "Ces catégories sont présentées à titre indicatif. Aucune offre spécifique n'est publiée sur cette page ; les opportunités concrètes sont discutées directement avec notre équipe.",
    categoriesTitle: "Catégories",
    cats: {
      real_estate_career: { title: "Carrière en immobilier", body: "Développement de carrière, d'équipes et de réseaux dans le secteur immobilier." },
      insurance_career: { title: "Carrière en assurance et services financiers", body: "Parcours d'entrée, qualifications requises et développement consultatif." },
      sales_representative: { title: "Représentation commerciale", body: "Vente-conseil, acquisition de clientèle et développement de territoire." },
      campaign_representative: { title: "Représentation en campagne", body: "Campagnes commerciales, activations et projets caritatifs." },
      business_development: { title: "Développement des affaires", body: "Création d'opportunités, partenariats et croissance organisationnelle." },
      automotive_sales: { title: "Secteur automobile", body: "Opportunités commerciales et développement d'affaires dans l'industrie automobile." },
      leadership_development: { title: "Développement du leadership", body: "Accompagnement des personnes qui souhaitent encadrer et faire grandir des équipes." },
      project_opportunity: { title: "Opportunité de projet", body: "Participation à des projets structurés, en développement ou en expansion." },
    },
  },
  realEstate: {
    kicker: "Immobilier",
    title: "Développer des talents, des équipes et des projets immobiliers",
    lead: "Consultants Sparks accompagne le développement de talents, de réseaux, d'équipes et d'opportunités dans le secteur immobilier.",
    p1: "Le secteur immobilier est une verticale importante de nos activités : carrières, développement de réseaux, structuration d'équipes de vente et projets de développement.",
    p2: "Nous travaillons avec un réseau international de professionnels de l'immobilier et de partenaires spécialisés. Par respect de la confidentialité, aucun nom de partenaire n'est publié sans autorisation explicite.",
    areasKicker: "Champs d'action",
    areas: [
      { title: "Carrières", body: "Accompagnement des personnes qui souhaitent bâtir une carrière dans l'immobilier." },
      { title: "Développement de réseaux", body: "Croissance et structuration de réseaux professionnels." },
      { title: "Équipes de vente", body: "Construction et développement d'équipes performantes." },
      { title: "Projets de développement", body: "Contribution à des projets résidentiels et commerciaux." },
      { title: "Partenariats", body: "Création de relations durables avec des partenaires spécialisés." },
      { title: "Expansion internationale", body: "Développement de marchés au-delà des frontières." },
    ],
  },
  humanDev: {
    kicker: "Développement humain",
    title: "Une organisation grandit lorsque les personnes qui la composent grandissent",
    lead: "Le développement humain est au cœur de Consultants Sparks.",
    p1: "Nous accompagnons les personnes dans la découverte de leur potentiel, le développement de leurs compétences et la construction d'un parcours professionnel cohérent.",
    disclaimer: "Nous ne promettons aucun revenu et ne garantissons aucune progression automatique. Chaque parcours dépend de l'engagement, des compétences et du contexte de la personne.",
    itemsKicker: "Notre accompagnement",
    items: [
      { title: "Accompagnement", body: "Un suivi humain, structuré et respectueux du rythme de chacun." },
      { title: "Leadership", body: "Développer la capacité à encadrer, décider et faire grandir les autres." },
      { title: "Carrière", body: "Construire un parcours cohérent, étape par étape." },
      { title: "Formation", body: "Acquérir les compétences nécessaires au rôle visé." },
      { title: "Coaching", body: "Des échanges réguliers pour progresser concrètement." },
      { title: "Progression", body: "Prendre des responsabilités et contribuer à des projets plus larges." },
    ],
  },
  projects: {
    kicker: "Projets",
    title: "Transformer des opportunités en projets structurés",
    lead: "Consultants Sparks développe des projets : commerciaux, immobiliers, d'expansion, de recrutement ou de partenariat.",
    p1: "Un projet commence rarement par un plan complet. Il commence par une opportunité, une équipe et une méthode.",
    typesKicker: "Types de projets",
    types: [
      { title: "Immobilier", body: "Projets résidentiels, commerciaux et de développement." },
      { title: "Commercial", body: "Développement de marchés et d'opportunités d'affaires." },
      { title: "Expansion", body: "Croissance territoriale et organisationnelle." },
      { title: "Recrutement", body: "Structuration d'équipes et de capacités humaines." },
      { title: "Partenariat", body: "Alliances structurées entre organisations." },
      { title: "Investissement", body: "Projets nécessitant une structuration financière." },
    ],
    processKicker: "Notre méthode",
    process: [
      { title: "Exploration", body: "Comprendre l'opportunité et son contexte." },
      { title: "Qualification", body: "Valider la faisabilité et les conditions de réussite." },
      { title: "Structuration", body: "Définir l'équipe, les étapes et les responsabilités." },
      { title: "Développement", body: "Exécuter, mesurer et ajuster." },
    ],
  },
  careers: {
    kicker: "Carrières",
    title: "Trouvez votre prochaine opportunité",
    lead: "Découvrez où votre potentiel peut vous mener. Une seule candidature générale suffit pour amorcer la conversation.",
    howKicker: "Comment ça fonctionne",
    how: [
      { title: "Soumettre", body: "Remplissez la candidature générale en quelques minutes." },
      { title: "Échanger", body: "Un membre de notre équipe communique avec vous." },
      { title: "Orienter", body: "Nous identifions ensemble la direction la plus cohérente." },
      { title: "Démarrer", body: "Vous commencez avec un accompagnement structuré." },
    ],
    noFake: "Nous ne publions aucune offre fictive. Les opportunités concrètes sont présentées directement lors de nos échanges.",
  },
  contactAdmin: {
    title: "Messages de contact",
    lead: "Messages reçus par le formulaire public, avec leur état de synchronisation vers le CRM VytaliLeads.",
    empty: "Aucun message pour le moment.",
    select: "Sélectionnez un message.",
    syncLabel: "Synchronisation CRM",
    attempts: "tentative(s)",
    resend: "Retransmettre au CRM",
    filterAll: "Tous",
    filterFailed: "À retransmettre",
    filterUnread: "Nouveaux",
    noUnread: "Aucun nouveau message.",
    source: "Source",
    sourceUnknown: "Source inconnue",
    srcPage: "Page",
    srcLanding: "Page d'arrivée",
    srcLanguage: "Langue",
    srcChannel: "Canal",
    srcReferrer: "Référent",
    noFailed: "Aucun message à retransmettre.",
    resendOk: "Message retransmis au CRM.",
    resendFailed: "La retransmission a échoué. Le message reste conservé.",
    notConfigured: "La connexion serveur-à-serveur VytaliLeads n'est pas configurée. Les messages sont conservés ici et pourront être retransmis une fois la configuration en place.",
  },
  contact: {
    kicker: "Nous joindre",
    title: "Parler avec notre équipe",
    lead: "Une question, un projet, une candidature ? Écrivez-nous.",
    name: "Nom complet",
    email: "Courriel",
    subject: "Sujet",
    message: "Message",
    send: "Envoyer le message",
    success: "Merci. Votre message a été transmis à notre équipe.",
  },
  apply: {
    kicker: "Candidature générale",
    title: "Découvrez où votre potentiel peut vous mener",
    lead: "Vous n'avez pas besoin de savoir exactement quel chemin vous convient. Répondez simplement, nous vous orienterons.",
    steps: ["Vos coordonnées", "Votre expérience", "Vos intérêts", "Consentements"],
    fields: {
      firstName: "Prénom",
      lastName: "Nom",
      email: "Courriel",
      phone: "Téléphone",
      city: "Ville",
      provinceState: "Province / État",
      country: "Pays",
      language: "Langue préférée",
      employmentStatus: "Situation actuelle",
      currentRole: "Poste actuel",
      yearsExperience: "Années d'expérience",
      education: "Scolarité",
      availability: "Disponibilité",
      transportation: "Transport",
      experienceTitle: "Expériences pertinentes",
      sales: "Expérience en vente",
      leadership: "Expérience en leadership",
      realEstate: "Expérience en immobilier",
      insurance: "Expérience en assurance",
      automotive: "Expérience en automobile",
      entrepreneurship: "Expérience entrepreneuriale",
      mobilityTitle: "Mobilité",
      travel: "Prêt à voyager",
      remote: "Intérêt pour le travail à distance",
      relocation: "Ouvert à la relocalisation",
      interests: "Domaines d'intérêt",
      careerGoals: "Objectifs de carrière",
      motivation: "Ce qui vous motive",
      referralSource: "Comment nous avez-vous connus ?",
    },
    options: {
      employment: { employed: "En emploi", self_employed: "Travailleur autonome", student: "Aux études", between_jobs: "En transition", other: "Autre" },
      years: { "0-1": "0 à 1 an", "2-3": "2 à 3 ans", "3-5": "3 à 5 ans", "5-10": "5 à 10 ans", "10+": "Plus de 10 ans" },
      education: { high_school: "Secondaire", college: "Collégial", university: "Universitaire", other: "Autre" },
      availability: { immediate: "Immédiate", "2_weeks": "Dans 2 semaines", "1_month": "Dans 1 mois", flexible: "Flexible" },
      transportation: { car: "Voiture", public: "Transport en commun", none: "Aucun" },
      referral: { web: "Recherche web", social: "Réseaux sociaux", referral: "Référence d'une personne", event: "Événement", other: "Autre" },
    },
    consent: {
      age: "Je confirme avoir 18 ans ou plus.",
      process: "J'autorise Consultants Sparks à traiter mes renseignements dans le cadre de l'évaluation de ma candidature.",
      marketing: "J'accepte de recevoir des communications sur les opportunités et les activités de Consultants Sparks (facultatif).",
      version: "Version du consentement",
      separateNote: "Le consentement au traitement de la candidature est distinct du consentement aux communications marketing.",
    },
    ageError: "Vous devez confirmer avoir 18 ans ou plus.",
    consentError: "Le consentement au traitement de votre candidature est requis.",
    validation: {
      stepError: "Veuillez remplir les champs obligatoires de cette étape avant de continuer.",
      required: "Ce champ est obligatoire.",
      email: "Veuillez saisir une adresse courriel valide.",
      phone: "Veuillez saisir un numéro de téléphone valide (au moins 6 caractères).",
      country: "Veuillez saisir un pays valide.",
    },
    success: {
      title: "Candidature reçue",
      body: "Merci. Votre candidature a été enregistrée et un membre de notre équipe communiquera avec vous.",
      account: "Créez votre compte pour suivre l'évolution de votre dossier.",
    },
  },
  auth: {
    loginTitle: "Connexion",
    loginLead: "Accédez à votre portail Consultants Sparks.",
    registerTitle: "Créer un compte",
    registerLead: "Créez votre compte pour suivre votre dossier.",
    email: "Courriel",
    password: "Mot de passe",
    firstName: "Prénom",
    lastName: "Nom",
    forgotLink: "Mot de passe oublié ?",
    noAccount: "Pas encore de compte ?",
    hasAccount: "Vous avez déjà un compte ?",
    forgotTitle: "Mot de passe oublié",
    forgotLead: "Nous vous enverrons un lien de réinitialisation.",
    forgotSent: "Si un compte existe, un lien de réinitialisation a été envoyé.",
    resetTitle: "Nouveau mot de passe",
    resetLead: "Choisissez un nouveau mot de passe.",
    resetDone: "Mot de passe mis à jour. Vous pouvez vous connecter.",
    verifyTitle: "Vérification du courriel",
    verifying: "Vérification en cours…",
    verified: "Votre adresse courriel est vérifiée.",
    verifyFailed: "Ce lien de vérification est invalide ou expiré.",
    passwordRule: "Minimum 8 caractères.",
    unverified: "Votre adresse courriel n'est pas encore vérifiée.",
    resend: "Renvoyer le courriel de vérification",
    resent: "Courriel de vérification envoyé.",
  },
  portal: {
    title: "Mon portail",
    welcome: "Bonjour",
    statusTitle: "Statut de mon dossier",
    noApplication: "Aucune candidature n'est associée à ce compte pour le moment.",
    applyNow: "Soumettre ma candidature",
    currentStage: "Étape actuelle",
    historyTitle: "Historique",
    profileTitle: "Mon profil",
    accountTitle: "Mon compte",
    nextStepTitle: "Prochaine étape",
    nextStep: {
      new: "Votre candidature a été reçue. Notre équipe l'examine.",
      to_contact: "Notre équipe communiquera avec vous prochainement.",
      contacted: "Un premier contact a été établi. Restez attentif à nos messages.",
      prequalification: "Une préqualification est en cours.",
      interview_scheduled: "Une rencontre est planifiée avec notre équipe.",
      interview_completed: "Votre rencontre est complétée. Nous revenons vers vous.",
      evaluation: "Votre dossier est en évaluation.",
      orientation: "Nous identifions la direction professionnelle la plus cohérente.",
      training: "Une étape de formation est en cours.",
      ready_deployment: "Votre dossier est prêt pour un démarrage.",
      active: "Vous êtes actif au sein de nos activités.",
      progressing: "Vous progressez dans votre parcours.",
      not_retained: "Votre dossier n'a pas été retenu pour le moment.",
      inactive: "Votre dossier est actuellement inactif.",
    },
    updated: "Profil mis à jour.",
    settingsLang: "Langue des communications",
  },
  admin: {
    dashboard: "Tableau de bord",
    candidates: "Candidats",
    pipeline: "Pipeline",
    users: "Utilisateurs",
    audit: "Journal d'audit",
    livechat: "Ask Vytali",
    contact: "Messages",
    recruitment: "Recrutement",
    settings: "Réglages",
    kpi: {
      total: "Candidats au total",
      new: "Nouveaux candidats",
      active: "Candidats actifs",
      unassigned: "Non assignés",
    },
    byStage: "Candidats par étape",
    byVertical: "Candidats par intérêt",
    byGeo: "Candidats par territoire",
    bySource: "Candidats par source",
    recent: "Candidatures récentes",
    tasksDue: "Suivis à faire",
    noTasks: "Aucun suivi en attente.",
    scopeAssigned: "Portée : vos candidats assignés",
    scopeAll: "Portée : tous les candidats",
    table: { name: "Nom", contact: "Contact", location: "Territoire", stage: "Étape", recruiter: "Recruteur", created: "Créé le", interests: "Intérêts", actions: "Actions" },
    view: "Consulter",
    assignTo: "Assigner à",
    assignSuccess: "Assignation mise à jour.",
    stageChanged: "Étape mise à jour.",
    candidateNotFound: "Candidat introuvable ou hors de votre périmètre.",
    downloadDenied: "Téléchargement non autorisé pour ce candidat.",
    accessDenied: "Accès refusé : cette section est réservée aux administrateurs.",
    claim: "Prendre en charge",
    unassign: "Retirer l'assignation",
    unassigned: "Non assigné",
    changeStage: "Changer d'étape",
    stageReason: "Motif (facultatif)",
    notes: "Notes internes",
    addNote: "Ajouter une note",
    notePlaceholder: "Note interne…",
    sensitive: "Note sensible",
    noNotes: "Aucune note.",
    tasks: "Suivis",
    addTask: "Ajouter un suivi",
    taskTitle: "Titre du suivi",
    dueDate: "Échéance",
    markDone: "Marquer complété",
    done: "Complété",
    open: "En cours",
    noTasksCandidate: "Aucun suivi.",
    history: "Historique du pipeline",
    profile: "Profil du candidat",
    experience: "Expérience",
    consent: "Consentements",
    searchPlaceholder: "Nom, courriel, téléphone…",
    filterStage: "Étape",
    filterVertical: "Intérêt",
    filterRecruiter: "Recruteur",
    filterCountry: "Pays",
    resultsCount: "résultat(s)",
    noResults: "Aucun candidat ne correspond à ces critères.",
    usersTitle: "Utilisateurs et rôles",
    role: "Rôle",
    status: "Statut",
    activeLabel: "Actif",
    inactiveLabel: "Inactif",
    lastSuperAdmin: "Le dernier super_admin actif est protégé.",
    unassignedPool: "Bassin non assigné",
    auditTitle: "Journal d'audit",
    auditActor: "Acteur",
    auditAction: "Action",
    auditEntity: "Entité",
    auditDate: "Date",
    settingsCompany: "Entreprise",
    settingsLanguages: "Langues",
    settingsRecruitment: "Recrutement",
    settingsEmail: "Courriel",
    settingsPrivacy: "Confidentialité",
    settingsSecurity: "Sécurité",
    settingsSaved: "Réglages enregistrés.",
    securityNote: "Authentification par JWT, mots de passe hachés (bcrypt), limitation de tentatives, RBAC appliqué côté serveur.",
    emailNote: "L'identité d'expédition est configurée par variables d'environnement et n'est pas modifiable ici.",
    privacyNote: "Les noms d'organisations privées ne sont jamais exposés publiquement sans autorisation explicite.",
  },
  stages: {
    new: "Nouveau",
    to_contact: "À contacter",
    contacted: "Contacté",
    prequalification: "Préqualification",
    interview_scheduled: "Entrevue planifiée",
    interview_completed: "Entrevue complétée",
    evaluation: "Évaluation",
    orientation: "Orientation",
    training: "Formation",
    ready_deployment: "Prêt au déploiement",
    active: "Actif",
    progressing: "En progression",
    not_retained: "Non retenu",
    inactive: "Inactif",
  },
  verticals: {
    REAL_ESTATE: "Immobilier",
    INSURANCE_FINANCIAL_SERVICES: "Assurances et services financiers",
    SALES_CAMPAIGNS: "Vente et campagnes commerciales",
    CHARITY_CAMPAIGNS: "Campagnes caritatives",
    AUTOMOTIVE: "Automobile",
    BUSINESS_DEVELOPMENT: "Développement des affaires",
    PROJECTS_PARTNERSHIPS: "Projets et partenariats",
  },
  documents: {
    title: "Mes documents",
    rules: "Formats acceptés",
    sizeUnit: "Mo",
    type: "Type de document",
    types: { resume: "Curriculum vitæ", certification: "Attestation / certification", other: "Autre document" },
    upload: "Téléverser un document",
    uploaded: "Document téléversé.",
    deleted: "Document supprimé.",
    failed: "Le téléversement a échoué.",
    errCode: {
      INVALID_FILE_TYPE: "Format non accepté. Formats permis : PDF, DOC, DOCX, JPG, JPEG, PNG.",
      INVALID_MIME: "Le contenu du fichier ne correspond pas à son extension. Réenregistrez le document puis réessayez.",
      FILE_TOO_LARGE: "Fichier trop volumineux (maximum 8 Mo). Compressez le PDF puis réessayez.",
      EMPTY_FILE: "Le fichier est vide. Sélectionnez un document valide.",
      INVALID_DOCUMENT_TYPE: "Type de document non pris en charge.",
      STORAGE_UNAVAILABLE: "Le stockage des documents est momentanément indisponible. Réessayez dans quelques instants.",
      UNAUTHORIZED: "Votre session a expiré. Reconnectez-vous puis réessayez.",
      CANDIDATE_NOT_FOUND: "Aucune candidature liée à ce compte : soumettez d'abord votre candidature.",
      UPLOAD_FAILED: "Le téléversement a échoué. Réessayez dans quelques instants.",
    },
    errType: "Format non accepté. Formats permis : PDF, DOC, DOCX, JPG, JPEG, PNG.",
    errSize: "Fichier trop volumineux. Taille maximale : 8 Mo.",
    errInvalid: "Fichier invalide ou vide.",
    errAuth: "Vous devez être connecté pour téléverser un document.",
    empty: "Aucun document pour le moment.",
    download: "Télécharger",
    delete: "Supprimer",
    staffTitle: "Documents du candidat",
  },
  stats: {
    title: "Mes statistiques",
    scope: "Portée : votre activité personnelle",
    assigned: "Candidats assignés",
    new7: "Nouveaux (7 jours)",
    openTasks: "Suivis en cours",
    overdue: "Suivis en retard",
    activity: "Activité",
    moves7: "Changements d'étape (7 j)",
    moves30: "Changements d'étape (30 j)",
    notes30: "Notes (30 j)",
    claimed: "Prises en charge",
    recentMoves: "Mouvements récents",
  },
  footer: {
    tagline: "Projets. Humains. Croissance.",
    legal: "Légal",
    privacy: "Politique de confidentialité",
    terms: "Conditions d'utilisation",
    explore: "Explorer",
    organization: "Organisation",
    account: "Compte",
    rights: "Tous droits réservés.",
    addressLabel: "Adresse officielle",
    address: "2828, boul. Laurier, suite 700\nQuébec (Québec) G1V 0B9\nCanada",
    confidentiality: "Consultants Sparks protège la confidentialité de ses relations d’affaires, de ses partenaires et de ses candidats. Les opportunités peuvent varier selon le profil, l’expérience, les qualifications et les besoins des organisations.",
    navTitle: "Navigation",
    contactTitle: "Nous joindre",
    callUs: "Appelez-nous",
    phone: "+1 418-549-6833",
    askTitle: "Ask Vytali",
    askLead: "Une question sur un parcours, un projet ou un partenariat ? Posez-la et notre équipe vous répond.",
    askCta: "Poser une question",
    askSoon: "Posez votre question à Ask Vytali",
  },
  chat: {
    launcher: "Ask Vytali",
    open: "Ouvrir le clavardage Ask Vytali",
    callAria: "Appeler Consultants Sparks",
    close: "Fermer le clavardage Ask Vytali",
    subtitle: "Assistance en direct · Consultants Sparks",
    placeholder: "Écrivez votre question…",
    send: "Envoyer",
    typing: "Ask Vytali écrit…",
    error: "La conversation est momentanément indisponible. Vous pouvez nous joindre au +1 418-549-6833.",
    greeting: "Bonjour, je suis Ask Vytali de Consultants Sparks. Ravie de vous rencontrer. Qu'est-ce qui vous amène aujourd'hui ?",
    disclaimer: "Ask Vytali est une assistante conversationnelle. Aucune décision ni garantie d'emploi, de revenu ou d'entrevue n'est émise par ce clavardage.",
  },
};

export default fr;
